const INSTALLATION_STORAGE_KEY = 'bolt-protect:poc:v1:installation-id';

let cachedInstallationId;

function createUuidV4() {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex
    .slice(6, 8)
    .join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
}

export function getInstallationId() {
  if (cachedInstallationId) {
    return cachedInstallationId;
  }

  const stored = localStorage.getItem(INSTALLATION_STORAGE_KEY);
  if (stored) {
    cachedInstallationId = stored;
    return stored;
  }

  cachedInstallationId = createUuidV4();
  localStorage.setItem(INSTALLATION_STORAGE_KEY, cachedInstallationId);
  return cachedInstallationId;
}

export class ApiError extends Error {
  constructor(code, message, status) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
  }
}

async function request(path, init = {}) {
  const response = await fetch(path, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      'X-Installation-Id': getInstallationId(),
      ...init.headers,
    },
  });

  const body = await response.json().catch(() => null);
  if (!response.ok) {
    throw new ApiError(
      body?.error?.code ?? 'REQUEST_FAILED',
      body?.error?.message ?? 'Сервер не смог выполнить запрос.',
      response.status,
    );
  }
  return body;
}

export function getSubscriptionStatus() {
  return request('/api/status', { method: 'GET' });
}

export function prepareSubscription() {
  return request('/api/subscription/prepare', {
    method: 'POST',
    body: '{}',
  });
}

export function confirmSubscription(payload) {
  return request('/api/subscription/confirm', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function deactivateSubscription() {
  return request('/api/subscription/deactivate', {
    method: 'POST',
    body: '{}',
  });
}
